import { render, staticRenderFns } from "./ProductPostingStatus.vue?vue&type=template&id=b177737a&scoped=true"
import script from "./ProductPostingStatus.vue?vue&type=script&lang=js"
export * from "./ProductPostingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b177737a",
  null
  
)

export default component.exports